var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-switch-button"},[(_vm.load)?_c('Feather',{staticClass:"v-switch-button__icon",attrs:{"type":"loader","animation":"spin"}}):_c('label',{staticClass:"v-switch-button__label",class:{ 'v-switch-button__label--checked': this.checked },on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }